import { api } from '@/app/api';
import { OfertaResponse } from '@/app/api/types';
import { DefaultResponse } from '@/app/helpers/types';

export type LoginTokens = {
  token: string;
  refreshToken?: string;
};

export type LoginFactorResponse = DefaultResponse<{
  name: string;
  tin: string;
  isCompany: boolean;
  isFactoringContractTemplateAdded: boolean;
  isRegisterOfDebtsTemplateAdded: boolean;
  mfo: string;
  roles: {
    isAdmin: boolean | null;
    isBranchEmploye: boolean | null;
    isHeadOfficeEmployee: boolean | null;
    isManager: boolean | null;
  };
  branchId: number | null;
}>;

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    loginBuyer: builder.mutation<
      LoginFactorResponse & LoginTokens,
      { token: string; factor: number }
    >({
      query: ({ token, factor }) => ({
        method: 'GET',
        url: '/noauth/login',
        params: {
          factor,
        },
        headers: {
          'user-key': token,
        },
      }),
    }),
    loginFactor: builder.mutation<
      LoginFactorResponse & LoginTokens,
      { token: string }
    >({
      query: ({ token }) => ({
        method: 'GET',
        url: '/noauth/login/factor',

        headers: {
          'user-key': token,
        },
      }),
    }),
    acceptOffer: builder.mutation<
      {
        isFactoringContractTemplateAdded: boolean;
        isRegisterOfDebtsTemplateAdded: boolean;
      },
      { signature: string; userKey: string; id: string | number }
    >({
      query: ({ signature, userKey, id }) => ({
        method: 'POST',
        url: 'noauth/offer/accept',
        body: { signature, id },
        headers: {
          'user-key': userKey,
        },
      }),
    }),
    acceptFactorOffer: builder.mutation<
      DefaultResponse<{
        isFactoringContractTemplateAdded: boolean;
        isRegisterOfDebtsTemplateAdded: boolean;
      }>,
      { signature: string; userKey: string; id: string | number }
    >({
      query: ({ signature, userKey, id }) => ({
        method: 'POST',
        url: '/noauth/offer/factor/accept',
        body: { signature, id },
        headers: {
          'user-key': userKey,
        },
      }),
    }),
    getOffer: builder.query<OfertaResponse, { userKey: string }>({
      query: ({ userKey }) => ({
        method: 'GET',
        url: 'noauth/documents/offer',
        headers: {
          'user-key': userKey,
        },
      }),
    }),
    getFactorOffer: builder.query<OfertaResponse, { userKey: string }>({
      query: ({ userKey }) => ({
        url: '/noauth/documents/offer/factor',
        method: 'GET',
        headers: {
          'user-key': userKey,
        },
      }),
    }),
    logoutUser: builder.mutation<
      { success: boolean },
      { refreshToken: string }
    >({
      query: (body) => ({
        method: 'POST',
        url: '/auth/logout',
        body,
      }),
    }),
  }),
});

export const {
  useLoginFactorMutation,
  useLoginBuyerMutation,
  useAcceptOfferMutation,
  useGetOfferQuery,
  useLazyGetOfferQuery,
  useGetFactorOfferQuery,
  useLazyGetFactorOfferQuery,
  useAcceptFactorOfferMutation,
  useLogoutUserMutation,
} = authApi;
